import { useCallback } from 'react';

import { useChangeNetSuiteRequest } from '../useChangeNetSuiteRequest/useChangeNetSuiteRequest';
import { CustomFieldUpdateHandler, GenericNetSuiteListItem } from './useUpdateLineCustomField.types';

export const useUpdateLineCustomField = <T extends GenericNetSuiteListItem>(
    setItems: (updater: (current: T[]) => T[]) => void
) => {
    const changeNetSuiteRequest = useChangeNetSuiteRequest();

    const updateCustomField = useCallback<CustomFieldUpdateHandler>(
        (lineId, field, valueKey, value) => {
            setItems((current) => {
                return current.map((line) => {
                    if (line.id !== lineId) {
                        return line;
                    }

                    const newLine = { ...line };

                    const hasCustomFieldState = line.customFields?.find(
                        (customField) => customField.companyFieldId === field.id
                    );

                    if (hasCustomFieldState) {
                        newLine.customFields = newLine.customFields?.map((customField) => {
                            if (customField.companyFieldId === field.id) {
                                return {
                                    ...customField,
                                    [valueKey]: value,
                                };
                            }

                            return customField;
                        });
                    } else {
                        newLine.customFields = [
                            ...(newLine.customFields || []),
                            {
                                companyFieldId: field.id,
                                scriptId: field.netSuiteField?.fieldScriptId || '',
                                internalId: field.netSuiteField?.id || '',
                                fieldType: field.netSuiteField?.type || '',
                                valueString: null,
                                valueRef: null,
                                valueRefs: null,
                                valueBoolean: null,
                                valueDate: null,
                                valueDecimal: null,
                                valueLong: null,
                                [valueKey]: value,
                            },
                        ];
                    }

                    return newLine;
                });
            });

            changeNetSuiteRequest();
        },
        [setItems, changeNetSuiteRequest] as const
    );

    return updateCustomField;
};
